import { api } from '../api';
import type { Region, RegionStats, CreateRegionInput } from '@/types/region';
import type { PaginationParams, PaginatedResponse } from '@/types/common';
import type { RegionRecipe } from '@/types/recipe';

export const regionApi = {
  paginate: (params?: PaginationParams & { isActive?: boolean; companyId?: number; include?: string[] }) => {
    const query = new URLSearchParams();
    if (params) {
      const { include, ...rest } = params;
      Object.entries(rest).forEach(([k, v]) => {
        if (v !== undefined && v !== null) query.set(k, String(v));
      });
      include?.forEach((v) => query.append('include', v));
    }
    const qs = query.toString();
    return api.get<PaginatedResponse<Region>>(`/regions${qs ? `?${qs}` : ''}`);
  },
  getById: (id: number, include?: string[]) => {
    const query = new URLSearchParams();
    include?.forEach((v) => query.append('include', v));
    const qs = query.toString();
    return api.get<Region>(`/regions/${id}${qs ? `?${qs}` : ''}`);
  },
  create: (data: CreateRegionInput) => api.post<Region>('/regions', data),
  update: (id: number, data: Partial<Region>) => api.patch<Region>(`/regions/${id}`, data),
  delete: (id: number) => api.delete(`/regions/${id}`),
  getStats: () => api.get<RegionStats>('/regions/stats'),
  getRecipes: (regionId: number, params?: { search?: string; source?: string }) => {
    const query = new URLSearchParams();
    if (params?.search) query.set('search', params.search);
    if (params?.source) query.set('source', params.source);
    const qs = query.toString();
    return api.get<RegionRecipe[]>(`/regions/${regionId}/recipes${qs ? `?${qs}` : ''}`);
  },
};
